import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api, setToken } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { PawPrint } from "lucide-react";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? match[1] : null;
    const run = async () => {
      if (!sessionId) { navigate("/login"); return; }
      try {
        const r = await api.post("/auth/session", {}, { headers: { "X-Session-ID": sessionId } });
        if (r.data.token) setToken(r.data.token);
        setUser(r.data.user);
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/");
      } catch {
        navigate("/login");
      }
    };
    run();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-background">
      <div className="h-12 w-12 rounded-2xl bg-primary flex items-center justify-center text-primary-foreground animate-pulse mb-3"><PawPrint className="h-6 w-6" /></div>
      <p className="text-muted-foreground">Signing you in...</p>
    </div>
  );
}
